<div>
    <!-- <div class="alert alert-warning">Section Summary</div> -->
    <ng-container>

        <ng-container *ngIf="showHeaderRow">

            <div class="Vert-15"></div>

            <div class="row">
                <div class="col-6">
                    <span class="review-submit-title">{{sectionLabel}}</span>
                </div>
                <div class="col-6" style="text-align:right">
                    <div>
                        <button class="btn white" (click)="lgvFormSvc.navigate(this.level1Param, this.level2Param)" [disabled]="lgvFormSvc.isReadOnlyMode">{{lgvFormSvc.editButtonLabelFromSummary(summary)}}</button>
                    </div>
                </div>
            </div>

        </ng-container>

        <div>

            <div class="have-missing-wrapper">
                <div class="row">
                    <!-- Have List -->
                    <div *ngIf="summary.numChanged > 0" class="col-12 col-lg-6">
                        <div class="Vert-15" *ngIf="showHeaderRow"></div>
                        <!-- <b>Have List:</b> -->
                        <div *ngFor="let fieldStatus of summary.fieldList">
                            <div *ngIf="fieldStatus.changed && !fieldStatus.hidden">{{fieldStatus.label}}
                                <span *ngIf="!fieldStatus.arrayItems">
                                    <b> {{ fieldStatus?.currentLabel ?? fieldStatus?.currentVal | boolean }}</b>
                                </span>
                            </div>
                            <ng-container *ngIf="fieldStatus.arrayItems">
                                <ul>
                                    <ng-container *ngFor="let arrayItem of fieldStatus.arrayItems">
                                        <li *ngIf="!arrayItem.hidden">{{displayArrayObject(arrayItem)}}</li>
                                    </ng-container>
                                </ul>
                            </ng-container>
                        </div>
                    </div>


                    <!-- Missing List -->
                    <div *ngIf="summary.numRequiredRemaining > 0" class="errorText col-12 col-lg-6">
                        <div class="Vert-15" *ngIf="showHeaderRow"></div>
                        <b>Missing List</b>
                        <ul>
                            <ng-container *ngFor="let fieldStatus of summary.fieldList">
                                <li *ngIf="fieldStatus.missing">{{fieldStatus.label}}</li>
                            </ng-container>
                        </ul>
                    </div>

                </div>
            </div>

        </div>
        <div class="Vert-20"></div>

    </ng-container>


</div>
